export const THREADS_RESET = "THREADS_RESET";
export const THREADS_LIVE_STARTED = "THREADS_LIVE_STARTED";
export const THREADS_LIVE_SNAPSHOT = "THREADS_LIVE_SNAPSHOT";
export const THREADS_LIVE_ERROR = "THREADS_LIVE_ERROR";
export const THREADS_OLDER_REQUEST = "THREADS_OLDER_REQUEST";
export const THREADS_OLDER_SUCCESS = "THREADS_OLDER_SUCCESS";
export const THREADS_OLDER_FAILURE = "THREADS_OLDER_FAILURE";
export const THREADS_SET_HAS_MORE = "THREADS_SET_HAS_MORE";
